var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"top","colored-border":"","type":"info","elevation":"2","color":"blue"}},[_vm._v(" Página não encontrada. "),_c('router-link',{attrs:{"to":"/inicio"}},[_vm._v("Voltar ao início")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }